import React from "react";
import "./AboutUs.css";
import Header from "./Header";
import WhyChooseUs from "./WhyChooseUs";
import Footer from "./Footer";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";

const AboutUs = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.3,
  });

  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0 });
    } else {
      controls.start({ opacity: 0, y: -50 });
    }
  }, [inView, controls]);

  return (
    <>
      <Header />
   
      {/* <div className="about-containe container ">
        <div className="row align-items-center">
           <h2 className="about-heading mb-4">Why Own a Home in Barsana?</h2>
          <div className="col-md-5 pini mt-5">
           
            <ul class="dark-bullets">
              <li>
                <h5>Spiritual Peace and Mental Well-being</h5>
              </li>
            </ul>

            <p>
              Reconnect with your inner self in an environment that promotes
              peace, prayer, and positivity. Ideal for spiritual seekers, senior
              citizens, and anyone looking for a peaceful retreat from city
              chaos.
            </p>
            <ul class="dark-bullets">
              <li>
                <h5>Rising Pilgrimage Tourism Hub</h5>
              </li>
            </ul>

            <p>
              With increasing footfall from domestic and international devotees,
              Barsana is now becoming a real estate hotspot. Government
              initiatives under the Braj Development Plan are boosting
              infrastructure and connectivity in the region.
            </p>
            <ul class="dark-bullets">
              <li>
                <h5>Affordable and Appreciating Land</h5>
              </li>
            </ul>

            <p>
              Property prices are still relatively lower compared to Vrindavan
              and Mathura, but rapidly rising due to development. Excellent
              opportunity for early investors and second home buyers.
            </p>
            <ul class="dark-bullets">
              <li>
                <h5>Connectivity & Proximity</h5>
              </li>
            </ul>

            <p>
              Just 45 km from Mathura, 20 km from Govardhan, and 140 km from
              Delhi. Accessible via Yamuna Expressway and Agra–Delhi highway.
              New spiritual corridors and road widening projects are underway.
            </p>
             <ul class="dark-bullets">
              <li>
                <h5> Blissful Living Amid Nature</h5>
              </li>
            </ul>
            
            <p>
              Surrounded by verdant hills, sacred groves (vanas), and serene
              temples, Barsana offers unmatched tranquility. The air feels
              blessed, the water is sacred, and every sunrise is a divine
              experience.
            </p>
          </div>

          <div className="col-md-7 mt-5" ref={ref}>
             <img
                          src="/image/gallery1.jpg"
                          alt="Resort View"
                          className="img-fluid about-img-bottom"
                        />
            
                        <motion.img
                          src="/image/gallery2.jpg"
                          alt="People"
                          className="img-fluid   about-img-top shadow"
                          initial={{ opacity: 0, y: -50 }}
                          animate={controls}
                          transition={{ duration: 0.8, ease: "easeInOut" }}
                        />
            
          </div>
        </div>
      </div> */}
      

      <WhyChooseUs />
      {/* <ParkedVillasSection />
      <CurvedVillasSection />
      <PoolVillasSection /> */}
      {/* <LatestProperties /> */}
      <Footer />
    </>
  );
};

export default AboutUs;
